import { Component, OnInit, ViewChild, Inject, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { XAPILogComponent } from '@app/main/analytics/xapi-log/xapi-log.component';
import { fuseAnimations } from '@fuse/animations';
import { AssessmentResult, Course } from '@shared/models';
import { AssessmentService } from '@shared/services/assessment.service';


@Component({
  selector: 'program-reporting-session-log',
  templateUrl: './program-reporting-session-log.component.html',
  styleUrls: ['./program-reporting-session-log.component.scss'],
  animations: fuseAnimations
})

export class ProgramReportingSessionLogComponent implements OnInit {
  @Output() onExplore = new EventEmitter<{ assessmentResult: AssessmentResult, course: Course }>();
  public sessionId: string;
  public course: Course;
  public assessmentResult: AssessmentResult;
  @ViewChild(XAPILogComponent) logsComponent: XAPILogComponent;

  constructor(
    private _assessmentService: AssessmentService,
    public _dialogRef: MatDialogRef<ProgramReportingSessionLogComponent>,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: { sessionId:string, course: Course }
  ) {
    this.sessionId = _data.sessionId;
    this.course = _data.course;
  }

  async ngOnInit(): Promise<void> {
    this.assessmentResult = await this._assessmentService.getAssessmentBySessionId(this.sessionId).toPromise();
  }

  openAssessmentDashboard() {
    this.closeDialog();
    this.onExplore.emit({
      assessmentResult: this.assessmentResult,
      course: this.course
    });
  }

  downloadLogs() {
    this.logsComponent?.exportStats();
  }

  closeDialog() {
    this._dialogRef.close();
  }
}
